<template>
    <div
        style="background: rgba(232,240,255,0.2);border-radius: 4px;border: 1px solid #D9E4F8;padding:10px 24px;display: flex;flex-direction: column;align-items:start;">
        <div style="font-size: 12px;color: #0E193B;">{{ title }}</div>
        <div style="font-size: 14px;color: #0E193B;font-weight: bold;margin-top: 6px;">{{ value }}</div>

    </div>
</template>
<script>
export default{
    props:{
        title:{
            type:String,
            default:''
        },
        value:{
            type: [String, Number],
            default:''
        }
    },
 

}
</script>